/* eslint-disable consistent-return */
import produce from 'immer';
import { dimensionReducer } from "./dimension";
/**
 * Panels reducer.
 *
 * This handles state changes on the individual breakpoint level.
 */

export var panelsReducer = function panelsReducer(state, action) {
  return produce(state, function (draft) {
    switch (action.type) {
      case 'UPDATE':
        draft.rows = dimensionReducer(draft.rows, action);
        draft.columns = dimensionReducer(draft.columns, action);
        draft.areas = action.payload.template[draft.breakpoint].areas;
        break;

      case 'COMMIT':
      case 'COMMIT_ALL':
        draft.rows = dimensionReducer(draft.rows, action);
        draft.columns = dimensionReducer(draft.columns, action);
        draft.areaTemplate.set(areaStringFromArray(draft.areas));
        break;

      case 'UPDATE_CONTAINER_SIZE':
        draft.rows = dimensionReducer(draft.rows, action);
        draft.columns = dimensionReducer(draft.columns, action);
        break;

      case 'SNAPSHOT':
        draft[action.payload.dimension] = dimensionReducer(draft[action.payload.dimension], action);
        break;

      case 'PAN_START':
        draft.activeDimension = action.payload.dimension;
        draft.activeIndex = action.payload.index;
        draft[action.payload.dimension] = dimensionReducer(draft[action.payload.dimension], action);
        break;

      case 'PAN':
      case 'TOGGLE_SHOWING':
        draft[action.payload.dimension] = dimensionReducer(draft[action.payload.dimension], action);
        break;

      case 'PAN_END':
        draft[draft.activeDimension] = dimensionReducer(draft[draft.activeDimension], action);
        draft.activeDimension = null;
        draft.activeIndex = null;
        break;

      default:
        return state;
    }
  });
};

function areaStringFromArray(areas) {
  return areas.reduce(function (accumulator, area) {
    accumulator.push("\"".concat(area.join(' '), "\""));
    return accumulator;
  }, []).join('\n');
}